import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Transfer, UpdateTransferDTO } from "@models/transfer";
import { SnackBarService } from "./snack-bar.service";
import { catchError, tap } from "rxjs";
import { Page } from "@models/page";
import { PaginatorState } from "primeng/paginator";

@Injectable({
  providedIn: "root",
})
export class TransfersService {
  private readonly baseUrl = `${environment.API_BACKEND}`;

  private readonly http = inject(HttpClient);

  private readonly snackbarService = inject(SnackBarService);

  bulkTransfer(saleIds: number[], userEmail: string, userPhoneNumber?: string) {
    return this.http.post(`${this.baseUrl}/my_tickets/transfer/bulk`, {
      sale_ids: saleIds,
      user_email: userEmail,
      user_phone_number: userPhoneNumber,
    });
  }

  acceptTransfer(id: number) {
    return this.http.patch(`${this.baseUrl}/transfers/${id}/accept`, {}).pipe(
      tap(() =>
        this.snackbarService.openSnackBar(
          "Transferência aceita com sucesso",
          "Fechar",
          "success",
        ),
      ),
      catchError((err) => {
        this.snackbarService.openSnackBar(
          "Erro ao aceitar transferência",
          "Fechar",
          "error",
        );

        return err;
      }),
    );
  }

  declineTransfer(id: number) {
    return this.http.patch(`${this.baseUrl}/transfers/${id}/decline`, {}).pipe(
      tap(() =>
        this.snackbarService.openSnackBar(
          "Transferência recusada com sucesso",
          "Fechar",
          "success",
        ),
      ),
      catchError((err) => {
        this.snackbarService.openSnackBar(
          "Erro ao recusar transferência",
          "Fechar",
          "error",
        );

        return err;
      }),
    );
  }

  getSentTransfers(pageEvent?: PaginatorState) {
    const params = new HttpParams()
      .set("page", pageEvent?.page ?? 0)
      .set("per_page", pageEvent?.rows ?? 10);

    return this.http.get<Page<Transfer>>(`${this.baseUrl}/my_transfers/sent`, {
      params,
    });
  }

  getReceivedTransfers(pageEvent?: PaginatorState) {
    const params = new HttpParams()
      .set("page", pageEvent?.page ?? 0)
      .set("per_page", pageEvent?.rows ?? 10);

    return this.http.get<Page<Transfer>>(
      `${this.baseUrl}/my_transfers/received`,
      { params },
    );
  }

  updateTransfer(id: number, body: UpdateTransferDTO) {
    return this.http.patch(`${this.baseUrl}/transfers/${id}`, { body }).pipe(
      tap(() =>
        this.snackbarService.openSnackBar(
          "Transferência atualizada com sucesso",
          "Fechar",
          "success",
        ),
      ),
      catchError((err) => {
        this.snackbarService.openSnackBar(
          "Erro ao atualizar transferência",
          "Fechar",
          "error",
        );

        return err;
      }),
    );
  }

  deleteTransfer(id: number) {
    return this.http.delete(`${this.baseUrl}/transfers/${id}`).pipe(
      tap(() =>
        this.snackbarService.openSnackBar(
          "Transferência removida com sucesso",
          "Fechar",
          "success",
        ),
      ),
      catchError((err) => {
        this.snackbarService.openSnackBar(
          "Erro ao remover transferência",
          "Fechar",
          "error",
        );

        return err;
      }),
    );
  }
}
